<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="7" height="10" viewBox="0 0 7 10">
    <path fill="none" fill-rule="evenodd" stroke="#13A2E8" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M0 4L4 8 8 4" opacity=".9" transform="rotate(-90 3.28 5.75)" />
  </svg>
</template>